<template>
  <q-card flat bordered class="q-pa-md">
    <p
      class="text-subtitle1 text-bold"
      :class="$q.dark.mode === true ? '' : 'text-primary'"
    >
      Level Alert of {{ symbol }}
    </p>

    <div class="row q-pb-sm">
      <div class="justify-left q-gutter-sm">
        <q-radio
          v-model="timePeriod"
          val="hourly"
          label="Hourly"
          color="red"
          keep-color
        />
        <q-radio
          v-model="timePeriod"
          val="daily"
          label="Daily"
          color="cyan"
          keep-color
        />
        <q-radio
          v-model="timePeriod"
          val="weekly"
          label="Weekly"
          color="cyan"
          keep-color
        />
      </div>
      <q-space />
    </div>

    <div v-if="mappedArray.length">
      <q-list bordered separator>
        <q-item v-for="item in mappedArray" :key="item">
          <q-item-section side top>
            <div
              class="text-caption text-bold"
              :class="$q.dark.mode === true ? '' : 'text-primary'"
            >
              {{ timePeriod === "hourly" ? convertDate(item.date) : item.date }}
            </div>
          </q-item-section>

          <q-item-section>
            <ul style="text-decoration: none">
              <li
                v-for="[key, value] in Object.entries(item.message)"
                :key="key"
              >
                <span
                  :style="
                    key.slice(-1) === 'n'
                      ? { color: 'red' }
                      : { color: 'green' }
                  "
                  class="text-body2"
                  >{{ value }}</span
                >
              </li>
            </ul>
          </q-item-section>
        </q-item>
        <q-separator />
      </q-list>
    </div>
    <div v-else class="q-pa-md">Loading...</div>
  </q-card>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import moment from "moment";
import { useQuasar } from "quasar";
import useLevelalert from "src/use/levelalert";

// Define the props
const props = defineProps({
  symbol: {
    type: String,
    default: "NEPSE",
  },
});
const $q = useQuasar();
const {
  LevelAlertIndicatorsSymbolwise,
  LevelAlertIndicatorsWeeklySymbolwise,
  LevelAlertIndicatorsHourlySymbolwise,
} = useLevelalert();

let timePeriod = ref("daily");
const mappedArray = ref([]);

async function loadData(apiFunction) {
  try {
    $q.loading.show({});
    const res = await apiFunction(props.symbol);
    mappedArray.value = res.data.map((item) => {
      let { id, date, symbol, ...message } = item;
      return { id, date, symbol, message };
    });
    $q.loading.hide({});
  } catch (error) {
    console.error(error);
  } finally {
    $q.loading.hide();
  }
}

function updateDataBasedOnTimePeriod(timePeriodValue) {
  if (timePeriodValue === "daily") {
    loadData(LevelAlertIndicatorsSymbolwise);
  }
  if (timePeriodValue === "hourly") {
    loadData(LevelAlertIndicatorsHourlySymbolwise);
  }
  if (timePeriodValue === "weekly") {
    loadData(LevelAlertIndicatorsWeeklySymbolwise);
  }
}

const convertDate = (date) => {
  const newDate = moment(date).format("YYYY-MM-DD, hh A");
  return newDate;
};

watch(
  () => timePeriod.value,
  (newVal, oldVal) => {
    updateDataBasedOnTimePeriod(newVal);
  }
);

watch(
  () => props.symbol,
  (newVal, oldVal) => {
    updateDataBasedOnTimePeriod(timePeriod.value);
  }
);

onMounted(() => {
  updateDataBasedOnTimePeriod(timePeriod.value);
});
</script>
